import {
  APIContributor,
  ArdoqId,
  UserDataForRenderers,
} from '@ardoq/api-types';

const toUserDataForRenderers = ({
  _id,
  name,
  email,
  image,
}: APIContributor): UserDataForRenderers => ({ _id, name, email, image });

export const toUsersDataForRenderersById = (
  users: APIContributor[]
): Record<ArdoqId, UserDataForRenderers> =>
  Object.fromEntries(
    users.map(user => [user._id, toUserDataForRenderers(user)])
  );
